import React, { useEffect } from 'react';

import { initializeHttpProvider } from '@/providers/HttpProvider/initializeHttpProvider';
import { IResDashboard, UnsuccessfulDeliveries } from '@/types/parcel/dashboard';

import { useDate } from '../Context/DateContext';

interface StateData {
  data: UnsuccessfulDeliveries['deliveries'] | null;
  loading: boolean;
  error: boolean;
}

const useUnsuccessfulDeliveries = () => {
  const { selectedDate } = useDate();
  const [data, setData] = React.useState<StateData>({
    data: null,
    loading: true,
    error: false,
  });

  const getUnsuccessfulDeliveries = async () => {
    const http = initializeHttpProvider();
    try {
      const response = await http.dashboard.unsuccessfulDeliveries(selectedDate);

      setData({
        data: (response as IResDashboard<UnsuccessfulDeliveries>).data.deliveries,
        loading: false,
        error: false,
      });
    } catch {
      setData({ data: null, loading: false, error: true });
    }
  };

  useEffect(() => {
    getUnsuccessfulDeliveries();
  }, [selectedDate]);

  return {
    data,
  };
};

export default useUnsuccessfulDeliveries;
